import { AbstractPmsApiService } from "./abstract.service";
import { ReservationSource } from "../models";

/**
 * @class ReservationSourcePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ReservationSource>}
 */
export class ReservationSourcePmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/reservation-source(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {ReservationSource}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new ReservationSource(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ReservationSource>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ReservationSource} reservationSource
     * @param {Property} property
     * @returns {Promise.<ReservationSource>}
     */
    create(reservationSource, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, reservationSource.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ReservationSource} reservationSource
     * @returns {Promise.<ReservationSource>}
     */
    update(reservationSource) {
        
        const url = this.url({
            propertyId: reservationSource.property.id,
            id:         reservationSource.id
        });
        
        return this.http
                   .put(url, reservationSource.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ReservationSource} reservationSource
     * @returns {Promise.<boolean>}
     */
    delete(reservationSource) {
        
        const url = this.url({
            propertyId: reservationSource.property.id,
            id:         reservationSource.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-source.service.js